// src/queries/about.query.js
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query'
import { getRequest, postRequest, deleteRequest } from 'utils/http' // Assuming getRequest, postRequest, deleteRequest are defined here

// =========================================================
//                  ABOUT US QUERIES
// =========================================================

const ABOUT_US_QUERY_KEY = 'about-us'

export const getAboutUs = async () => {
  return getRequest('abouts') 
}

export const useGetAboutUs = () => {
  return useQuery({
    queryKey: [ABOUT_US_QUERY_KEY],
    queryFn: getAboutUs,
    // The API response has { status, message, data: [...] }, so extract data[0]
    select: data =>
      data?.data && Array.isArray(data.data) && data.data.length > 0
        ? data.data[0]
        : null,
  })
}

export const createOrUpdateAboutUs = async formData => {
  return postRequest('about', formData)
}

export const useCreateOrUpdateAboutUs = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: formData => createOrUpdateAboutUs(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ABOUT_US_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to create or update about us information:', error)
    },
  })
}

// =========================================================
// Deletion (Optional - generally not for a single global record)
// =========================================================
/**
 * Deletes the single About Us record.
 * Backend: DELETE /api/abouts/{id} (calls AboutController@destroy)
 * @param {string} id - The ID of the about record to delete (expected to be '1' or similar).
 */
export const deleteAboutUs = async id => {
  return deleteRequest(`abouts/${id}`)
}

export const useDeleteAboutUs = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: id => deleteAboutUs(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ABOUT_US_QUERY_KEY] })
      // You might also redirect or show a message that about info is gone
    },
    onError: error => {
      console.error('Failed to delete about us information:', error)
    },
  })
}
